export default "__VITE_ASSET__BmYOL6ZL__";